import { Component } from '../core/Component';

/**
 * Linear velocity for movement.
 */
export class Velocity extends Component {
  /** Horizontal velocity in pixels per second */
  vx: number = 0;
  /** Vertical velocity in pixels per second */
  vy: number = 0;
}
